import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import Modal from "../../components/Modal.jsx";
import FormControl from "../../components/form/FormControl.jsx";
import FormButton from "../../components/form/FormButton.jsx";
import useDownloadState from "../../api/utilities/useDownloadState.js";
import FormError from "../../components/form/FormError.jsx";
import {ProjectApi} from "../../api/authority/generated/index";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";
import toast from "react-hot-toast";
import Button from "../../components/Button.jsx";

export default function ProjectInvitationButton({project, onFinally}) {

    let {getAuthorityConfiguration, resetCurrentUserProjects} = useContext(GlobalContext);
    let {t} = useTranslation();

    let [modalOpen, setModalOpen] = useState();

    let [invitePressed, setInvitePressed] = useState(false);
    let [email, setEmail] = useState('');

    let [state, setDownloading, setResult, setError] = useDownloadState();

    useEffect(() => {

        if (!invitePressed) {
            return;
        }

        setInvitePressed(false);
        setDownloading(true);

        new ProjectApi(getAuthorityConfiguration())
            .inviteUser({
                projectId: project.id,
                inviteUserInput: {
                    userEmailAddress: email
                }
            })
            .then(() => {
                resetCurrentUserProjects();
                setModalOpen(false);
                toast.success(t('auth.invitation-sent'));
            })
            .catch(setError)
            .finally(() => setDownloading(false));
    }, [invitePressed]);

    return (
        <>
            <Button onClick={() => setModalOpen(true)}>
                {t('project.invite-user')}
            </Button>
            {modalOpen &&
                <Modal
                    visible={modalOpen}
                    setVisible={setModalOpen}
                    loading={state.downloading}
                    title={t('project.send-invitation')}
                    className={'max-w-lg'}
                >
                    <div>{t('auth.email-address')}:</div>
                    {state.error !== null && <FormError error={state.error}/>}
                    <FormControl value={email} onChange={(e) => setEmail(e.target.value)}/>
                    <FormButton
                        className={'button button-primary'}
                        onClick={() => {
                            setInvitePressed(true);
                        }}
                    >
                        {t('project.send-invitation')}
                    </FormButton>
                </Modal>
            }
        </>
    );
}